module.exports = __webpack_public_path__ + "img/firework-1.68ce51d8.png";